import React, { useEffect, useState } from 'react';
import { showErrorToast } from '@fff-web/fff-ui-shared/Toast';
import Address, { ADDRESS_LAYOUT_TYPES } from '@fff-web/fff-ui-shared/Address';

import PageContainer from 'pages/MyAccount/shared-components/PageContainer/PageContainer';
import useScreenMode from '../../../hooks/useScreenMode';
import { getAddresses } from '../services/api/address';
import PersonalInformation from './PersonalInformation';
import styles from './AccountDetailsPage.module.css';
import Credits from './Credits/Credits';
import Payment from './Payment/Payment';
import ManageMembership from './ManageMembership/ManageMembership';
import SectionContainer from './SectionContainer/SectionContainer';

const AccountDetailsPage = ({
  firstName,
  lastName,
  phone,
  email,
  shippingAddress,
  credits,
  billingInfo,
  setBillingInfo,
  isClubMember,
}) => {
  const { address1, address2, city, region, code: zipcode, country } = shippingAddress || {};

  const formState = {
    firstName,
    lastName,
    phone,
    email,
    address1,
    address2,
    city,
    region,
    zipcode,
    country,
  };
  const [formData, setFormData] = useState(formState);
  const [addresses, setAddresses] = useState(null);

  const updateUserInfo = (data) => {
    setFormData((prevState) => {
      return { ...prevState, ...data };
    });
  };

  useEffect(() => {
    const fetchAddresses = async () => {
      try {
        const addressResponse = await getAddresses();
        setAddresses(addressResponse);
      } catch (error) {
        showErrorToast(error);
      }
    };

    fetchAddresses();
  }, []);

  return (
    <PageContainer>
      <div className={styles.container} data-testid="account-details-container">
        <div className={styles.header} data-testid="account-details-header">
          <h1>Account Details</h1>
        </div>
        <SectionContainer className={styles.sectionContainerTitle}>
          <PersonalInformation
            firstName={formData.firstName}
            lastName={formData.lastName}
            email={formData.email}
            updateUserInfo={updateUserInfo}
          />
        </SectionContainer>
        <SectionContainer title="Shipping Address" className={styles.sectionContainer}>
          <Address
            addressesData={addresses}
            layoutType={ADDRESS_LAYOUT_TYPES.userAccount}
          />
        </SectionContainer>
        <SectionContainer className={styles.sectionContainerTitle}>
          <Payment billingInfo={billingInfo} setBillingInfo={setBillingInfo} />
        </SectionContainer>
        <SectionContainer title="Credits & Discounts" className={styles.sectionContainerTitle}>
          <Credits credits={credits} />
        </SectionContainer>
        {!isClubMember && (
          <SectionContainer title="Manage Membership" className={styles.sectionContainer}>
            <ManageMembership />{' '}
          </SectionContainer>
        )}
      </div>
    </PageContainer>
  );
};
export default AccountDetailsPage;
